var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0804 11.669C11.8511 11.669 11.6635 11.8566 11.666 12.0859C11.666 12.3151 11.8536 12.5027 12.0829 12.5027C12.3121 12.5027 12.4997 12.3151 12.4997 12.0859C12.4997 11.8566 12.3121 11.669 12.0804 11.669",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0804 7.50234C11.8511 7.50234 11.6635 7.68992 11.666 7.91918C11.666 8.14845 11.8536 8.33602 12.0829 8.33602C12.3121 8.33602 12.4997 8.14845 12.4997 7.91918C12.4997 7.68992 12.3121 7.50234 12.0804 7.50234",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0804 15.8357C11.8511 15.8357 11.6635 16.0233 11.666 16.2525C11.666 16.4818 11.8536 16.6694 12.0829 16.6694C12.3121 16.6694 12.4997 16.4818 12.4997 16.2525C12.4997 16.0233 12.3121 15.8357 12.0804 15.8357",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0804 3.33242C11.8511 3.33242 11.6635 3.52 11.666 3.74926C11.666 3.97852 11.8536 4.1661 12.0829 4.1661C12.3121 4.1661 12.4997 3.97852 12.4997 3.74926C12.4997 3.52 12.3121 3.33242 12.0804 3.33242",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91339 11.669C7.68413 11.669 7.49655 11.8566 7.49905 12.0859C7.49905 12.3151 7.68663 12.5027 7.91589 12.5027C8.14515 12.5027 8.33273 12.3151 8.33273 12.0859C8.33273 11.8566 8.14515 11.669 7.91339 11.669",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91339 7.50234C7.68413 7.50234 7.49655 7.68992 7.49905 7.91918C7.49905 8.14845 7.68663 8.33602 7.91589 8.33602C8.14515 8.33602 8.33273 8.14845 8.33273 7.91918C8.33273 7.68992 8.14515 7.50234 7.91339 7.50234",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91339 15.8357C7.68413 15.8357 7.49655 16.0233 7.49905 16.2525C7.49905 16.4818 7.68663 16.6694 7.91589 16.6694C8.14515 16.6694 8.33273 16.4818 8.33273 16.2525C8.33273 16.0233 8.14515 15.8357 7.91339 15.8357",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91339 3.33242C7.68413 3.33242 7.49655 3.52 7.49905 3.74926C7.49905 3.97852 7.68663 4.1661 7.91589 4.1661C8.14515 4.1661 8.33273 3.97852 8.33273 3.74926C8.33273 3.52 8.14515 3.33242 7.91339 3.33242",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.f2549b9ecddfc0a3462da95a7255af04.svg";
export { ForwardRef as ReactComponent };